import { createSelector } from 'reselect';

import * as types from '../actions/actionTypes';
import { getUserSelectedFashionSize } from './userdata';

/**
 * Reducer to keep the currently selected sewing pattern in state.
 *
 * @param state
 * @param action
 * @returns {*}
 */
export default (state, action) => {
    switch (action.type) {
        case types.PRODUCT_SELECTED:
            return Object.assign({}, state, {
                productId: action.productId,
            });

        default:
            return state;
    }
};

/**
 * Reducer for changing the language specific sewpat data.
 *
 * @param state
 * @param action
 * @param languages
 * @returns {*}
 */
export const products = (state, action, languages) => {
    switch (action.type) {
        case types.LOCALE_CHANGED:
            return Object.assign({}, languages[action.currentLanguage].products);

        case types.LOCALE_SETTED_FROM_URI:
            return Object.assign({}, languages[action.language].products);

        default:
            return state;
    }
};

export const getProducts = state => state.stolo.i18n.products;
export const getActiveProductId = state => state.stolo.product.productId;

/**
 * Returns the active products selected values data.
 */
export const getActiveProductSelectedValues = createSelector([
    getActiveProductId, getProducts], (productId, products) => {
    const product = products[productId];
    return product.selectedValues;
});

/**
 * Returns the active products selected values data.
 */
export const getActiveProductData = createSelector([
    getActiveProductId, getProducts], (productId, products) => {
    const product = products[productId];
    return product.productData;
});



// WEBPACK FOOTER //
// ./src/reducers/products.js